import { makeStyles } from '@material-ui/core';

export const SIZE = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
};

export const COLOR = {
  ERROR: 'error',
  INFO: 'info',
  INHERIT_TEXT: 'inheritText',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  WARNING: 'warning',
};

export const useStyles = makeStyles((theme) => {
  const themeColorsMap = {
    [COLOR.ERROR]: {
      color: theme.palette.error.main,
    },
    [COLOR.INFO]: {
      color: theme.palette.info.main,
    },
    [COLOR.INHERIT_TEXT]: {
      color: theme.palette.text.primary,
    },
    [COLOR.PRIMARY]: {
      color: theme.palette.primary.main,
    },
    [COLOR.SECONDARY]: {
      color: theme.palette.secondary.main,
    },
    [COLOR.SUCCESS]: {
      color: theme.palette.success.main,
    },
    [COLOR.WARNING]: {
      color: theme.palette.warning.main,
    },
  };

  const containerMarginMap = {
    [SIZE.LARGE]: theme.spacing(2),
    [SIZE.MEDIUM]: theme.spacing(1.5),
    [SIZE.SMALL]: theme.spacing(1),
  };

  const labelMarginMap = {
    [SIZE.LARGE]: -theme.spacing(0.25),
    [SIZE.MEDIUM]: theme.spacing(0.25),
    [SIZE.SMALL]: 0,
  };

  return {
    checkedCheckbox: {
      color: (props) => themeColorsMap[props.color].color,
    },
    checkboxContainer: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      minHeight: `${theme.spacing(6.5)}px`,
      marginLeft: (props) => `-${containerMarginMap[props.size]}px`,
    },
    uncheckedCheckbox: {
      color: theme.palette.grey[700],
    },
    label: {
      marginLeft: (props) => `${labelMarginMap[props.size]}px`,
    },
  };
});
